import { render, staticRenderFns } from "./VerificationCode.vue?vue&type=template&id=53b54aa7&"
import script from "./VerificationCode.vue?vue&type=script&lang=js&"
export * from "./VerificationCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports